import React, { useState } from 'react';

function NewsletterSignup() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSignup = async () => {
    setMessage('');
    try {
      const response = await fetch('/api/public/signup-newsletter', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify( email )
      });

      const text = await response.text(); 
      if (response.ok) {
        setMessage("✅ " + "Signed Up");
        setEmail('');
      } else {
        setMessage("❌ " + text);
      }
    } catch {
      setMessage("❌ Something went wrong.");
    }
  };

  return (
    <div style={{ color: '#fff', textAlign: 'center', marginTop: '2rem' }}>
      <h4 style={{ fontSize: '1.2rem', marginBottom: '1rem' }}>Stay in the loop — join our newsletter</h4>
      <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '0.5rem' }}>
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{
            padding: '0.6rem 1rem',
            fontSize: '1rem',
            borderRadius: '4px',
            border: '1px solid #666',
            width: '260px',
            backgroundColor: '#333',
            color: '#fff'
          }}
        />
        <button
          onClick={handleSignup}
          style={{
            padding: '0.6rem 1.5rem',
            fontSize: '1rem',
            borderRadius: '4px',
            border: 'none',
            backgroundColor: '#00bfa5',
            color: '#000',
            fontWeight: 'bold',
            cursor: 'pointer'
          }}
        >
          Subscribe
        </button>
      </div>
      {message && (
        <p style={{ marginTop: '0.75rem', color: message.startsWith("✅") ? '#80ffea' : '#f44336' }}>
          {message}
        </p>
      )}
    </div>
  );
}

export default NewsletterSignup;
